"use client";

import type { ReactNode } from "react";
import { CopyButton } from "@/components/tool-kit/primitives";
import { HINT, LABEL, RESULT_CARD } from "@/components/tool-kit/styles";

/**
 * One converted version of the reader's text with its copy button — the result card
 * the text family's style generators share. Every word arrives through props, so each
 * widget's own strings (and their translations) reach it.
 */
export function StyledResult({
  label,
  value,
  emptyText,
  copyLabel,
  copiedLabel,
  hint,
}: {
  label: string;
  value: string;
  emptyText: string;
  copyLabel: string;
  copiedLabel: string;
  hint?: ReactNode;
}) {
  return (
    <div className={`${RESULT_CARD} space-y-2`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className={LABEL}>{label}</p>
        <CopyButton
          copiedLabel={copiedLabel}
          label={copyLabel}
          small
          text={value}
        />
      </div>
      <p className="min-h-7 whitespace-pre-wrap break-words text-foreground text-lg leading-relaxed">
        {value.length > 0 ? (
          value
        ) : (
          <span className="text-muted-foreground text-sm">{emptyText}</span>
        )}
      </p>
      {hint ? <p className={HINT}>{hint}</p> : null}
    </div>
  );
}
